import { render, staticRenderFns } from "./AppHeader.html?vue&type=template&id=b404a5f4&external"
import script from "./AppHeader.js?vue&type=script&lang=js&external"
export * from "./AppHeader.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports